module.exports = __webpack_public_path__ + "static/media/heart34.48013d9f.svg";